<template>
    <div class="xxdata">

<!--        <div>-->
<!--            <vs-checkbox icon-pack="feather" icon="icon-minus">Primary</vs-checkbox>-->
<!--        </div>-->
<!--        <vs-input class="inputx tree-search-input float-left mr-2" placeholder="查询" v-model.lazy="searchword" />-->

        <gc-cmp-vs-input label="" id="el_name" v-model="searchword" maxlength="200"
                         class="mb-5 xxfloat-left " placeholder="查询" @input="search"  />

<!--        <vs-button color="primary" type="filled" @click="search" class="mb-3">查询</vs-button>-->
<!--        <vs-button color="primary" type="filled" @click="queryChecked" class="mb-3">查看</vs-button>-->
        <v-tree ref="tree"  :data="treeData" :draggable="true" :tpl="tpl" :halfcheck="true" :multiple="true"/>
    </div>
</template>

<script type="text/jsx">
    import { VTree, VSelectTree}  from 'vue-tree-halower';
    import GcCmpVsInput from "@/group-cloud/components/vsInput";

    export default {
    name: 'role-tree-menu-form',
    components: {
        GcCmpVsInput,
        VTree,
        VSelectTree
    },
    props: {
        tree: {
            required: true,
            type: Array,
        }
    },
    data () {
        return {
            searchword: '',
            treeData: [],
            treeData2: [
                {
                    id: 4412,
                    title: 'node1',
                    expanded: true,
                    children: [
                        {
                            id: 48,
                            title: 'node 1-1',
                            expanded: true,
                            children: [
                                {
                                    id: 8,
                                    title: 'node 1-1-1'
                                }, {
                                    id: 9,
                                    title: 'node 1-1-2'
                                }, {
                                    id: 12,
                                    title: 'node 1-1-3'
                                }
                            ]
                        }, {
                            id: 49,
                            title: 'node 1-2',
                            children: [
                                {
                                    id: 51,
                                    title: 'node 1-2-1'
                                }, {
                                    id: 52,
                                    title: 'node 1-2-2'
                                }, {
                                    id: 55,
                                    title: 'node 1-2-3'
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    computed: {
    },
    watch: {
        tree(update) {
            this.treeData = update;
        }

    },
    methods: {
        search () {
            this.$refs.tree.searchNodes(this.searchword)
        },
        tpl (...args) {
            const {0: node, 2: parent, 3: index} = args
            let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
            if (node.searched) titleClass += ' node-searched'
            return <span>
                <span class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
                    this.$refs.tree.nodeSelected(node)
                }}></span>
            </span>
        },
        queryChecked() {
            let checked = this.$refs.tree.getNodes();
            let idx;
            let all_checked_ids = [];
            // console.log(['checked-nodes', checked]);
            for (idx = 0; idx < checked.length; idx++) {
                if (checked[idx].checked || checked[idx].halfcheck) {
                    all_checked_ids.push(checked[idx].id);
                }
            }
            // console.log(['checked-checked', all_checked_ids]);
            return all_checked_ids;
        },

    },
    created() {
    }
}
</script>

<style lang="scss">
    @import "../../../assets/scss/vuexy/extraComponents/tree.scss";

    button.btn-async{
        background: rgba(var(--vs-warning),0.15);
    }

    button.btn-delete{
        background: rgba(var(--vs-danger),0.15);
    }
</style>
